(function () {
  var SCROLL_THRESHOLD = 10;

  function init() {
    var headerWrapper = document.querySelector('.header-wrapper');

    if (headerWrapper) {
      function updateScrolled() {
        if (window.scrollY > SCROLL_THRESHOLD) {
          document.body.classList.add('sych-header-solid');
        } else {
          document.body.classList.remove('sych-header-solid');
        }
      }

      window.addEventListener('scroll', updateScrolled, { passive: true });
      updateScrolled();

      headerWrapper.addEventListener('mouseenter', function () {
        document.body.classList.add('sych-header-hover');
      });
      headerWrapper.addEventListener('mouseleave', function () {
        document.body.classList.remove('sych-header-hover');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
